/**
 * GUdaDialogs.ts
 * 
 * @author Jindřich Vácha
 * @since 480.2.0.0
 */
namespace Gordic.Uda.Dialogs {

    //-----------------------------------------------------------------------------------------------------
    /**
     * Vyvěšení na úřední desku
     * 
     * @author Jindřich Vácha
     * @since 480.2.0.0
     */
    export function VyveseniNaUredniDesku(
        parentContent: GContent,
        opt?: {
            /**
             * Ixp dokladu – povinné
             * @type {string}
             */
            Ixp: string,
            /**
             * Ixb souboru – volitelné, bude zaškrtnut
             * @type {string}
             */
            Ixb?: string,
            /**
             * Název – volitelné, předvyplní se
             * @type {string}
             */
            Nazev?: string,
            /**
             * Popis – volitelné, předvyplní se
             * @type {string}
             */
            Popis?: string
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQuery | undefined {

        const options = {
            Ixp: opt ? opt.Ixp : undefined,
            Ixb: opt ? opt.Ixb : undefined,
            Nazev: opt ? opt.Nazev : undefined,
            Popis: opt ? opt.Popis : undefined
        };

        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        if (ModOtevreni.indexOf("navigate") > -1) {
            return (pContent as any)[ModOtevreni]("Gordic.Uda.WebControls.VyveseniTabs", options);
        } else {
            return (((pContent as GContent).dialogs ? (pContent as GContent).dialogs : pContent) as any)
            [ModOtevreni]("Gordic.Uda.WebControls.VyveseniTabs", options, { title: "jres:Gordic.Uda.WebControls:24450063", width: 1000, height: 650 });  //RC 24450063 : Vyvěšení na úřední desku
        }
    } // VyveseniNaUredniDesku()

    //-----------------------------------------------------------------------------------------------------
    /**
     * Zveřejnění souboru
     * 
     * @author Jindřich Vácha
     * @since 480.2.0.0
     */
    export function ZverejneniSouboru(
        parentContent: GContent,
        opt?: {
            /**
             * Ixb souboru – povinné
             * @type {string}
             */
            Ixb: string,
            /**
             * Ixp dokladu – volitelné, ale raději uvést
             * @type {string}
             */
            Ixp?: string,
            /**
             * Název / titulek – volitelné, předvyplní se
             * @type {string}
             */
            Nazev?: string,
            /**
             * Popis – volitelné, předvyplní se
             * @type {string}
             */
            Popis?: string
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQuery | undefined {

        const options = {
            Ixb: opt ? opt.Ixb : undefined,
            Ixp: opt ? opt.Ixp : undefined,
            Nazev: opt ? opt.Nazev : undefined,
            Popis: opt ? opt.Popis : undefined
        };

        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        if (ModOtevreni.indexOf("navigate") > -1) {
            return (pContent as any)[ModOtevreni]("Gordic.Uda.WebControls.ZverejneniTabs", options);
        } else {
            return (((pContent as GContent).dialogs ? (pContent as GContent).dialogs : pContent) as any)
            [ModOtevreni]("Gordic.Uda.WebControls.ZverejneniTabs", options, { title: "jres:Gordic.Uda.WebControls:24450072", width: 1000, height: 650 });  //RC 24450072 : Zveřejnění souboru
        }
    } // ZverejneniSouboru()

    //-----------------------------------------------------------------------------------------------------
    /**
     * Zveřejnění souboru
     * 
     * @author Jindřich Vácha
     * @since 480.2.0.0
     */
    export function ZverejneniSouboruHistorie(
        parentContent: GContent,
        opt?: {
            /**
             * Ixb souboru – povinné
             * @type {string}
             */
            Ixb: string
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQuery | undefined {
        const options = {
            Ixb: opt ? opt.Ixb : undefined,
            HistOnly: true // jen historii
        };

        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        if (ModOtevreni.indexOf("navigate") > -1) {
            return (pContent as any)[ModOtevreni]("Gordic.Uda.WebControls.ZverejneniTabs", options);
        } else {
            return (((pContent as GContent).dialogs ? (pContent as GContent).dialogs : pContent) as any)
            [ModOtevreni]("Gordic.Uda.WebControls.ZverejneniTabs", options, { title: "jres:Gordic.Uda.WebControls:24450072", width: 1000, height: 650 });  //RC 24450072 : Zveřejnění souboru
        }
    } // ZverejneniSouboruHistorie()

} // ns